var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "content" },
    [
      _c("div", { staticClass: "header_search" }, [
        _c(
          "div",
          { staticClass: "topBtn" },
          [
            _c(
              "Button",
              {
                staticClass: "item",
                attrs: { icon: "ios-download-outline", type: "primary" },
                on: { click: _vm.excelCustomer }
              },
              [_vm._v("导出客户Excel")]
            ),
            _vm._v(" "),
            _c(
              "Button",
              {
                staticClass: "item",
                attrs: { icon: "ios-download-outline", type: "primary" },
                on: { click: _vm.exportReturnRecord }
              },
              [_vm._v("导出回访记录")]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticStyle: { "padding-top": "10px", "padding-right": "5px" } },
          [
            _c(
              "Form",
              {
                ref: "formValidate",
                attrs: { model: _vm.listQuery, "label-width": 90 }
              },
              [
                _c(
                  "Row",
                  [
                    _c(
                      "Col",
                      { attrs: { span: "4" } },
                      [
                        _c(
                          "FormItem",
                          { staticClass: "mb-10", attrs: { label: "门店" } },
                          [
                            _c("dropCheckBox", {
                              attrs: {
                                type: "signStoreList",
                                checkAllGroup: _vm.listQuery.store_id,
                                checkboxData: _vm.storeList,
                                placeholder: "请选择",
                                checkedValue: _vm.signStoreCheckedShowValue
                              },
                              on: { signStoreList_even: _vm.signStoreList }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "Col",
                      { attrs: { span: "4" } },
                      [
                        _c(
                          "FormItem",
                          {
                            staticClass: "mb-10",
                            attrs: { label: "客户搜索" }
                          },
                          [
                            _c("Input", {
                              attrs: { placeholder: "请输入客户姓名/手机号" },
                              model: {
                                value: _vm.listQuery.keywords,
                                callback: function($$v) {
                                  _vm.$set(_vm.listQuery, "keywords", $$v)
                                },
                                expression: "listQuery.keywords"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "Col",
                      { attrs: { span: "3" } },
                      [
                        _c(
                          "FormItem",
                          { staticClass: "mb-10", attrs: { label: "录入人" } },
                          [
                            _c("Input", {
                              attrs: { placeholder: "请输入录入人姓名" },
                              model: {
                                value: _vm.listQuery.enter_agent,
                                callback: function($$v) {
                                  _vm.$set(_vm.listQuery, "enter_agent", $$v)
                                },
                                expression: "listQuery.enter_agent"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "Col",
                      { attrs: { span: "6" } },
                      [
                        _c(
                          "FormItem",
                          {
                            staticClass: "mb-10",
                            attrs: { label: "录入时间" }
                          },
                          [
                            _c("DatePicker", {
                              staticStyle: { width: "45%" },
                              attrs: {
                                type: "date",
                                placeholder: "请选择录入开始时间",
                                options: _vm.startEntryTime,
                                format: "yyyy-MM-dd",
                                value: _vm.defaultStartEntryTime
                              },
                              on: {
                                "on-change": function($event) {
                                  return _vm.startTimeChange($event, 1)
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("span", [_vm._v(" 至 ")]),
                            _vm._v(" "),
                            _c("DatePicker", {
                              staticStyle: { width: "45%" },
                              attrs: {
                                type: "date",
                                placeholder: "请选择录入结束时间",
                                options: _vm.endEntryTime,
                                format: "yyyy-MM-dd",
                                value: _vm.defaultEndEntryTime
                              },
                              on: {
                                "on-change": function($event) {
                                  return _vm.endTimeChange($event, 1)
                                }
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.showOtherSearch
                      ? _c(
                          "Col",
                          { attrs: { span: "6" } },
                          [
                            _c(
                              "FormItem",
                              {
                                staticClass: "mb-10",
                                attrs: { label: "渠道" }
                              },
                              [
                                _c(
                                  "Select",
                                  {
                                    staticStyle: { width: "43%" },
                                    attrs: { placeholder: "请选择部门" },
                                    on: { "on-change": _vm.changeChannel },
                                    model: {
                                      value: _vm.listQuery.enter_department_id,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.listQuery,
                                          "enter_department_id",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "listQuery.enter_department_id"
                                    }
                                  },
                                  _vm._l(_vm.departmentList, function(item) {
                                    return _c(
                                      "Option",
                                      {
                                        key: item.id,
                                        attrs: { value: item.id }
                                      },
                                      [_vm._v(_vm._s(item.name))]
                                    )
                                  }),
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "Select",
                                  {
                                    staticStyle: { width: "43%" },
                                    attrs: {
                                      filterable: "",
                                      placeholder: "请选择渠道"
                                    },
                                    model: {
                                      value: _vm.listQuery.enter_channel_id,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.listQuery,
                                          "enter_channel_id",
                                          $$v
                                        )
                                      },
                                      expression: "listQuery.enter_channel_id"
                                    }
                                  },
                                  _vm._l(_vm.channelList, function(item) {
                                    return _c(
                                      "Option",
                                      {
                                        key: item.id,
                                        attrs: { value: item.id }
                                      },
                                      [_vm._v(_vm._s(item.name))]
                                    )
                                  }),
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.showOtherSearch
                      ? _c(
                          "Col",
                          { attrs: { span: "4" } },
                          [
                            _c(
                              "FormItem",
                              {
                                staticClass: "mb-10",
                                attrs: { label: "跟进状态" }
                              },
                              [
                                _c(
                                  "Select",
                                  {
                                    staticStyle: {},
                                    attrs: { placeholder: "请选择跟进状态" },
                                    model: {
                                      value: _vm.listQuery.follow_status_id,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.listQuery,
                                          "follow_status_id",
                                          $$v
                                        )
                                      },
                                      expression: "listQuery.follow_status_id"
                                    }
                                  },
                                  _vm._l(_vm.baseData.follow_status, function(
                                    item
                                  ) {
                                    return _c(
                                      "Option",
                                      {
                                        key: item.id,
                                        attrs: { value: item.id }
                                      },
                                      [_vm._v(_vm._s(item.name))]
                                    )
                                  }),
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.showOtherSearch
                      ? _c(
                          "Col",
                          { attrs: { span: "4" } },
                          [
                            _c(
                              "FormItem",
                              {
                                staticClass: "mb-10",
                                attrs: { label: "客户分组" }
                              },
                              [
                                _c("dropCheckBox", {
                                  attrs: {
                                    type: "member_group",
                                    checkAllGroup: _vm.listQuery.member_group,
                                    checkedValue: _vm.checkedShowValue,
                                    checkboxData: _vm.customerGroudList,
                                    placeholder: "请选择"
                                  },
                                  on: {
                                    member_group_even: _vm.member_group_even
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.showOtherSearch
                      ? _c(
                          "Col",
                          { attrs: { span: "3" } },
                          [
                            _c(
                              "FormItem",
                              {
                                staticClass: "mb-10",
                                attrs: { label: "用户类型" }
                              },
                              [
                                _c(
                                  "Select",
                                  {
                                    staticStyle: {},
                                    attrs: { placeholder: "请选择用户类型" },
                                    model: {
                                      value: _vm.listQuery.member_type_id,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.listQuery,
                                          "member_type_id",
                                          $$v
                                        )
                                      },
                                      expression: "listQuery.member_type_id"
                                    }
                                  },
                                  _vm._l(_vm.baseData.userType, function(item) {
                                    return _c(
                                      "Option",
                                      {
                                        key: item.id,
                                        attrs: { value: item.id }
                                      },
                                      [_vm._v(_vm._s(item.name))]
                                    )
                                  }),
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.showOtherSearch
                      ? _c(
                          "Col",
                          { attrs: { span: "6" } },
                          [
                            _c(
                              "FormItem",
                              {
                                staticClass: "mb-10",
                                attrs: { label: "分配时间" }
                              },
                              [
                                _c("DatePicker", {
                                  staticStyle: { width: "45%" },
                                  attrs: {
                                    type: "date",
                                    placeholder: "开始时间",
                                    options: _vm.startDistributionTime
                                  },
                                  on: {
                                    "on-change": function($event) {
                                      return _vm.startTimeChange($event, 2)
                                    }
                                  },
                                  model: {
                                    value: _vm.listQuery.agent_time_start,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.listQuery,
                                        "agent_time_start",
                                        $$v
                                      )
                                    },
                                    expression: "listQuery.agent_time_start"
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", [_vm._v(" 至 ")]),
                                _vm._v(" "),
                                _c("DatePicker", {
                                  staticStyle: { width: "45%" },
                                  attrs: {
                                    type: "date",
                                    placeholder: "结束时间",
                                    options: _vm.endDistributionTime
                                  },
                                  on: {
                                    "on-change": function($event) {
                                      return _vm.endTimeChange($event, 2)
                                    }
                                  },
                                  model: {
                                    value: _vm.listQuery.agent_time_end,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.listQuery,
                                        "agent_time_end",
                                        $$v
                                      )
                                    },
                                    expression: "listQuery.agent_time_end"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.showOtherSearch
                      ? _c(
                          "Col",
                          { attrs: { span: "3" } },
                          [
                            _c(
                              "FormItem",
                              {
                                staticClass: "mb-10",
                                attrs: { label: "录入方式" }
                              },
                              [
                                _c(
                                  "Select",
                                  {
                                    staticStyle: {},
                                    attrs: { placeholder: "请选择录入方式" },
                                    model: {
                                      value: _vm.listQuery.insert_way_id,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.listQuery,
                                          "insert_way_id",
                                          $$v
                                        )
                                      },
                                      expression: "listQuery.insert_way_id"
                                    }
                                  },
                                  _vm._l(_vm.baseData.insert_way, function(
                                    item
                                  ) {
                                    return _c(
                                      "Option",
                                      {
                                        key: item.id,
                                        attrs: { value: item.id }
                                      },
                                      [_vm._v(_vm._s(item.name))]
                                    )
                                  }),
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.showOtherSearch
                      ? _c(
                          "Col",
                          { attrs: { span: "3" } },
                          [
                            _c(
                              "FormItem",
                              {
                                staticClass: "mb-10",
                                attrs: { label: "当前状态" }
                              },
                              [
                                _c(
                                  "Select",
                                  {
                                    staticStyle: {},
                                    attrs: { placeholder: "请选择当前状态" },
                                    model: {
                                      value: _vm.listQuery.member_status,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.listQuery,
                                          "member_status",
                                          $$v
                                        )
                                      },
                                      expression: "listQuery.member_status"
                                    }
                                  },
                                  _vm._l(_vm.baseData.memberStatus, function(
                                    item
                                  ) {
                                    return _c(
                                      "Option",
                                      {
                                        key: item.id,
                                        attrs: { value: item.id }
                                      },
                                      [_vm._v(_vm._s(item.name))]
                                    )
                                  }),
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.showOtherSearch
                      ? _c(
                          "Col",
                          { attrs: { span: "8" } },
                          [
                            _c(
                              "FormItem",
                              {
                                staticClass: "mb-10",
                                attrs: { label: "跟进人" }
                              },
                              [
                                _c(
                                  "Select",
                                  {
                                    staticStyle: { width: "30%" },
                                    attrs: { placeholder: "请选择门店" },
                                    on: { "on-change": _vm.changeDepartment },
                                    model: {
                                      value: _vm.listQuery.follow_store_id,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.listQuery,
                                          "follow_store_id",
                                          $$v
                                        )
                                      },
                                      expression: "listQuery.follow_store_id"
                                    }
                                  },
                                  _vm._l(_vm.storeList, function(item) {
                                    return _c(
                                      "Option",
                                      {
                                        key: item.id,
                                        attrs: { value: item.id }
                                      },
                                      [_vm._v(_vm._s(item.name))]
                                    )
                                  }),
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "Select",
                                  {
                                    staticStyle: { width: "30%" },
                                    attrs: { placeholder: "请选择部门" },
                                    on: { "on-change": _vm.changeFollowr },
                                    model: {
                                      value: _vm.listQuery.follow_department_id,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.listQuery,
                                          "follow_department_id",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "listQuery.follow_department_id"
                                    }
                                  },
                                  _vm._l(_vm.followDepartmentList, function(
                                    item
                                  ) {
                                    return _c(
                                      "Option",
                                      {
                                        key: item.id,
                                        attrs: { value: item.id }
                                      },
                                      [_vm._v(_vm._s(item.name))]
                                    )
                                  }),
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "Select",
                                  {
                                    staticStyle: { width: "30%" },
                                    attrs: { placeholder: "请选择跟进人" },
                                    model: {
                                      value: _vm.listQuery.follow_agent_id,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.listQuery,
                                          "follow_agent_id",
                                          $$v
                                        )
                                      },
                                      expression: "listQuery.follow_agent_id"
                                    }
                                  },
                                  _vm._l(_vm.followrList, function(item) {
                                    return _c(
                                      "Option",
                                      {
                                        key: item.id,
                                        attrs: { value: item.id }
                                      },
                                      [_vm._v(_vm._s(item.user_name))]
                                    )
                                  }),
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.showOtherSearch
                      ? _c(
                          "Col",
                          { attrs: { span: "3" } },
                          [
                            _c(
                              "FormItem",
                              { attrs: { label: "跟进结果" } },
                              [
                                _c(
                                  "Select",
                                  {
                                    attrs: { placeholder: "跟进结果" },
                                    model: {
                                      value: _vm.listQuery.come_status_id,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.listQuery,
                                          "come_status_id",
                                          $$v
                                        )
                                      },
                                      expression: "listQuery.come_status_id"
                                    }
                                  },
                                  _vm._l(_vm.baseData.come_status, function(
                                    item
                                  ) {
                                    return _c(
                                      "Option",
                                      {
                                        key: item.id,
                                        attrs: { value: item.id }
                                      },
                                      [_vm._v(_vm._s(item.name))]
                                    )
                                  }),
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.showOtherSearch
                      ? _c(
                          "Col",
                          { attrs: { span: "4" } },
                          [
                            _c(
                              "FormItem",
                              { attrs: { label: "产后客户类型" } },
                              [
                                _c(
                                  "Select",
                                  {
                                    attrs: {
                                      placeholder: "请选择产后客户类型"
                                    },
                                    model: {
                                      value: _vm.listQuery.chankang_type,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.listQuery,
                                          "chankang_type",
                                          $$v
                                        )
                                      },
                                      expression: "listQuery.chankang_type"
                                    }
                                  },
                                  _vm._l(_vm.baseData.chankang_types, function(
                                    item
                                  ) {
                                    return _c(
                                      "Option",
                                      {
                                        key: item.id,
                                        attrs: { value: item.id }
                                      },
                                      [_vm._v(_vm._s(item.name))]
                                    )
                                  }),
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "Col",
                      {
                        staticClass: "opertionBtn_search",
                        attrs: { span: "6" }
                      },
                      [
                        _c(
                          "Button",
                          {
                            staticClass: "item",
                            attrs: { type: "primary", icon: "ios-search" },
                            on: { click: _vm.searchList }
                          },
                          [_vm._v("查询")]
                        ),
                        _vm._v(" "),
                        _c(
                          "Button",
                          {
                            staticClass: "item",
                            on: { click: _vm.emptyFilter }
                          },
                          [_vm._v("清空筛选")]
                        ),
                        _vm._v(" "),
                        _c(
                          "Button",
                          {
                            staticClass: "item",
                            staticStyle: { color: "#2d8cf0" },
                            attrs: { type: "text" },
                            on: { click: _vm.handleShowOtherSearch }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.showOtherSearch ? "收起" : "更多筛选")
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "FormItem",
                          {
                            staticStyle: { "margin-bottom": "0" },
                            attrs: { "label-width": 0 }
                          },
                          [
                            _c("autoTableItem", {
                              attrs: {
                                type: "chainCustomer",
                                defaultTable: _vm.defaultTable,
                                autoTableData: _vm.autoTableData,
                                placeholder: "表格展示项"
                              },
                              on: { autoTableRef: _vm.autoTableRef }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.showOtherSearch
                  ? _c(
                      "Row",
                      [
                        _c(
                          "Checkbox",
                          {
                            staticStyle: {
                              "margin-left": "15px",
                              "margin-bottom": "10px"
                            },
                            on: { "on-change": _vm.searchFirstTime },
                            model: {
                              value: _vm.firstEnterStatus,
                              callback: function($$v) {
                                _vm.firstEnterStatus = $$v
                              },
                              expression: "firstEnterStatus"
                            }
                          },
                          [_vm._v("仅查询首次录入时间")]
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "table_wrap" }, [
        _c(
          "div",
          { staticClass: "table_tip" },
          [
            _c(
              "Button",
              {
                attrs: { size: "small", type: "primary" },
                on: { click: _vm.addBatchWithPeople }
              },
              [_vm._v("分配跟进人")]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticStyle: { width: "100%" } },
          [
            _c("Table", {
              ref: "table",
              staticClass: "table_style",
              attrs: {
                stripe: "",
                border: "",
                columns: _vm.tabColumns,
                loading: _vm.tabLoading,
                data: _vm.tabData,
                height: _vm.tableHeight
              },
              on: {
                "on-sort-change": _vm.dataSort,
                "on-selection-change": _vm.batchAddFollow
              }
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  "margin-top": "20px",
                  display: "flex",
                  "justify-content": "flex-end"
                }
              },
              [
                _c("Page", {
                  attrs: {
                    "show-total": "",
                    "show-elevator": "",
                    "show-sizer": "",
                    "page-size-opts": _vm.pageSizeOpts,
                    "page-size": 50,
                    transfer: true,
                    total: _vm.total,
                    current: _vm.listQuery.page
                  },
                  on: {
                    "on-change": _vm.changePage,
                    "on-page-size-change": _vm.changeLimit
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "Modal",
        {
          attrs: {
            closable: false,
            styles: _vm.stylesModal,
            scrollable: true,
            "mask-closable": false,
            "class-name": "vertical-center-modal"
          },
          model: {
            value: _vm.showBatchAddWithPeople,
            callback: function($$v) {
              _vm.showBatchAddWithPeople = $$v
            },
            expression: "showBatchAddWithPeople"
          }
        },
        [
          _c(
            "p",
            {
              staticClass: "modal_title",
              attrs: { slot: "header" },
              slot: "header"
            },
            [
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.isModalTitle == 7
                      ? "分配跟进人"
                      : _vm.isModalTitle == 8
                      ? "删除跟进人"
                      : ""
                  )
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "p",
            { staticClass: "modal_text", staticStyle: { color: "#464c5b" } },
            [
              _vm._v(
                "\n      已选择" +
                  _vm._s(_vm.addBatchWithPeopleForm.member_ids.length) +
                  "条数据\n    "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "Form",
            {
              ref: "addBatchWithPeopleForm",
              staticStyle: { width: "70%" },
              attrs: {
                model: _vm.addBatchWithPeopleForm,
                rules: _vm.addBatchWithPeopleFormRule,
                "label-width": 80
              }
            },
            [
              _c(
                "FormItem",
                { attrs: { label: "门店", prop: "store_id" } },
                [
                  _c(
                    "Select",
                    {
                      attrs: { placeholder: "请选择门店", disabled: "" },
                      model: {
                        value: _vm.addBatchWithPeopleForm.store_id,
                        callback: function($$v) {
                          _vm.$set(_vm.addBatchWithPeopleForm, "store_id", $$v)
                        },
                        expression: "addBatchWithPeopleForm.store_id"
                      }
                    },
                    _vm._l(_vm.storeList, function(item) {
                      return _c(
                        "Option",
                        { key: item.id, attrs: { value: item.id } },
                        [_vm._v(_vm._s(item.name))]
                      )
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "FormItem",
                { attrs: { label: "部门", prop: "department_id" } },
                [
                  _c(
                    "Select",
                    {
                      attrs: { placeholder: "请选择部门" },
                      on: { "on-change": _vm.changeAddBatchFollowr },
                      model: {
                        value: _vm.addBatchWithPeopleForm.department_id,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.addBatchWithPeopleForm,
                            "department_id",
                            $$v
                          )
                        },
                        expression: "addBatchWithPeopleForm.department_id"
                      }
                    },
                    _vm._l(_vm.departmentList, function(item) {
                      return _c(
                        "Option",
                        { key: item.id, attrs: { value: item.id } },
                        [_vm._v(_vm._s(item.name))]
                      )
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "FormItem",
                { attrs: { label: "跟进人", prop: "follow_user" } },
                [
                  _c(
                    "Select",
                    {
                      attrs: { placeholder: "请选择跟进人" },
                      model: {
                        value: _vm.addBatchWithPeopleForm.follow_user,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.addBatchWithPeopleForm,
                            "follow_user",
                            $$v
                          )
                        },
                        expression: "addBatchWithPeopleForm.follow_user"
                      }
                    },
                    _vm._l(_vm.followrBatchAddList, function(item) {
                      return _c(
                        "Option",
                        { key: item.id, attrs: { value: item.id } },
                        [_vm._v(_vm._s(item.user_name))]
                      )
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "Button",
                {
                  attrs: {
                    type: "primary",
                    loading: _vm.followLoading,
                    size: "large"
                  },
                  on: {
                    click: function($event) {
                      return _vm.handleSubmit("addBatchWithPeopleForm")
                    }
                  }
                },
                [
                  !_vm.followLoading
                    ? _c("span", [_vm._v("确定")])
                    : _c("span", [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.isModalTitle == 7
                                ? " 分配跟进人中..."
                                : _vm.isModalTitle == 8
                                ? "删除跟进人中..."
                                : ""
                            ) +
                            "\n        "
                        )
                      ])
                ]
              ),
              _vm._v(" "),
              _c(
                "Button",
                {
                  attrs: { size: "large", loading: _vm.followLoading },
                  on: {
                    click: function($event) {
                      return _vm.handleReset("addBatchWithPeopleForm")
                    }
                  }
                },
                [
                  !_vm.followLoading
                    ? _c("span", [_vm._v("取消")])
                    : _c("span", [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.isModalTitle == 7
                                ? " 分配跟进人中..."
                                : _vm.isModalTitle == 8
                                ? "删除跟进人中..."
                                : ""
                            ) +
                            "\n        "
                        )
                      ])
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("customerExcel", {
        attrs: {
          excelTitle: _vm.excelTitle,
          excelSteps: _vm.excelSteps,
          downloadLink: _vm.downloadLink,
          customerExcelShow: _vm.customerExcelShow
        },
        on: { customerExcelEven: _vm.customerExcelEven }
      }),
      _vm._v(" "),
      _c("userAccessRecord", {
        attrs: {
          type: "chainCustomer",
          showAccessInfo: _vm.showAccessInfo,
          accessInfoType: _vm.accessInfoType,
          userId: _vm.userId
        },
        on: { Close: _vm.Close }
      }),
      _vm._v(" "),
      _c("userDetails", {
        attrs: {
          showUserDetails: _vm.showUserDetails,
          userId: _vm.userId,
          direct: "chainCustomer"
        },
        on: { Close: _vm.isEditorOk }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6d07591d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d07591d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Crm/UserManagement/chainCustomerNew.vue
// module id = null
// module chunks = 